
import {  useMutation, useInfiniteQuery } from "@tanstack/react-query";
import {  axiosPostRequest,axiosDeleteRequest,axiosGetRequest, axiosPutRequest, axiosGetRequestForInfiniteScroll, axiosPostRequestForInfiniteScroll} from "./request";

export const useGetRequests =  (options) =>{
  return useMutation({
    mutationFn: (params)=>{
      return axiosGetRequest(params.url, params.headers)},
      ...options
  })
}


export const useDeleteRequests = (options)=>{
  return useMutation({
    mutationFn: async ({url, headers})=>{
     return await axiosDeleteRequest(url, headers)
    },
      ...options
  })
}
export const usePutRequests = (options)=>{
  return useMutation({
    mutationFn: async ({url,data,headers})=>{
     return await axiosPutRequest(url, data, headers)
    },
      ...options
  })
}
export const usePostRequests = (options)=>{
  return useMutation({
    mutationFn: async ({url,data,headers})=>{
     return await axiosPostRequest(url, data, headers)
    },
      ...options
  })
}

export const useGetInfiniteScroll = (queryKey, url, data, totalPages) => {
  return useInfiniteQuery({
    queryKey: [queryKey],
    queryFn: async () => {
      if (data === "") {
        return await axiosGetRequestForInfiniteScroll(url);
      } else {
        return await axiosPostRequestForInfiniteScroll(url, data);
      }
    },

    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = allPages.length === totalPages ? false : true;
      return nextPage;
    },
    cacheTime: 0,
    refetchOnWindowFocus: false,
  });
};